<div class="wrapper">
    <!-- <span class="text-default">Best Practice <span class="small">1 of 12</span> </span> -->
  <div class="container px-0">
    <h5 class="main-title fw-bold mb-4">{{patientpersonalinfo?.PracticeName}}</h5>
    <!-- <div class="main-info">
      Please provide the following information to access the check-in flow.
  </div> -->
    <div class="px-2">
      <form [formGroup]="appointmentForm">
        <div class="">
          <p class="mb-2 fw-bold form-label">{{'Appointment.appointmentType.label' | translate}}<span class="text-danger">*</span> </p>
          <ul class="list-inline list-unstyled mb-0 new-symptoms-list" [ngClass]="{'rtl': isRtl}">

            <li class="list-inline-item">
              <div class="custom-control custom-radio">
                <input class="custom-control-input" type="radio" id="office" formControlName="appointmenttype"
                       value="office" (change)="selectAppointmenttype('office')">
                <label style="margin-bottom:0px !important;" class="custom-control-label cursor-pointer " for="office">
                  {{'Appointment.appointmentType.options.office' | translate}}
                </label>
              </div>
            </li>
            <li class="list-inline-item rd" style="margin-left: 60px;">
              <div class="custom-control custom-radio">
                <input class="custom-control-input" type="radio" id="telehealth" formControlName="appointmenttype"
                       value="telehealth" (change)="selectAppointmenttype('telehealth')">
                <label style="margin-bottom:0px !important;" class="custom-control-label cursor-pointer " for="telehealth">
                  {{'Appointment.appointmentType.options.telehealth' | translate}}
                </label>

              </div>
            </li>
          </ul>
          <div class="mb-2 err" *ngIf="getappointmentForm.appointmenttype.invalid && getappointmentForm.appointmenttype.touched && getappointmentForm.appointmenttype.errors!.required">
            {{'Appointment.appointmentType.requiredError' | translate}}
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-4">
            <div class="form-group border-bottom mb-2">
              <label class=" form-label fw-bold">{{'Appointment.provider.label' | translate}}<span class="text-danger">*</span></label>
              <div class="form-select">
                <select translate="no" class="form-control border-0" formControlName="provider" [ngStyle]="{'border' : getappointmentForm.provider.invalid
                                && getappointmentForm.provider.touched && getappointmentForm.provider.errors!.required ? '1px solid red' : ''}" (change)="onChangeDate()">
                  <option value="" disabled selected> {{'Appointment.provider.select_Provider' | translate}}</option>
                  <option *ngFor="let provider of providerData" [value]="provider.providerCode">{{provider.providerName}}</option>
                </select>
              </div>

            </div>
            <div class="mb-2">
              <span *ngIf="getappointmentForm.provider.invalid && getappointmentForm.provider.touched && getappointmentForm.provider.errors!.required" class="err">
                {{'Appointment.provider.requiredError' | translate}}
              </span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group border-bottom mb-2">
              <!-- <label class="d-md-block d-none mb-1">&nbsp;</label> -->
              <label class="form-label fw-bold">{{'Appointment.reason.label' | translate}}<span class="text-danger">*</span></label>
              <div class="form-select ">
                <select translate="no" class="form-control border-0" formControlName="reason" [ngStyle]="{'border' : getappointmentForm.reason.invalid
                            && getappointmentForm.reason.touched && getappointmentForm.reason.errors!.required ? '1px solid red' : ''}" (change)="onChangeDate()">
                  <option value="" disabled selected>{{'Appointment.reason.selectVisitReason' | translate}}</option>
                  <ng-container *ngIf="appointmentReasonData">
                    <option *ngFor="let reason of appointmentReasonData" [value]="reason.reasonId">{{reason.reasonName}}</option>
                  </ng-container>

                </select>
                <!--<label class="EigtheenInchesFontSize"
             [ngClass]="getappointmentForm.reason.invalid && getappointmentForm.reason.touched
        && getappointmentForm.reason.errors!.required ? 'text-danger' : ''">{{'Appointment.reason.label' | translate}} <span class="text-danger">*</span> </label>-->
              </div>

            </div>
            <div class="mb-2">
              <span *ngIf="getappointmentForm.reason.invalid && getappointmentForm.reason.touched && getappointmentForm.reason.errors!.required" class="err">
                {{'Appointment.reason.requiredError' | translate}}
              </span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group border-bottom mb-2">
              <label class="form-label fw-bold">{{'Appointment.appointmentDate.label' | translate}}<span class="text-danger">*</span></label>
              <div class="position-relative ">
                <input type="date" class="form-control border-0" min="{{minDate| date:'yyyy-MM-dd'}}" formControlName="DOappointment"
                       [ngStyle]="{'border' : getappointmentForm.DOappointment.invalid
                        && getappointmentForm.DOappointment.touched && getappointmentForm.DOappointment.errors!.required ? '1px solid red' : ''}"
                       placeholder="{{'Appointment.appointmentDate.label' | translate}}" (change)="onChangeDate()" (focusout)="focusOutFunction($event, 0)">
                <!--<label class="EigtheenInchesFontSize"
               [ngClass]="getappointmentForm.DOappointment.invalid && getappointmentForm.DOappointment.touched
        && getappointmentForm.DOappointment.errors!.required ? 'text-danger' : ''"> {{'Appointment.appointmentDate.label' | translate}} <span class="text-danger">*</span> </label>-->
              </div>

            </div>
            <div class="mb-2">
              <span *ngIf="getappointmentForm.DOappointment.invalid && getappointmentForm.DOappointment.touched && getappointmentForm.DOappointment.errors!.required" class="err">
                {{'Appointment.appointmentDate.requiredError' | translate}}
              </span>
            </div>
          </div>

          <div class="accordion col-md-12 mx-auto" *ngIf="appointmentTimeSlotFlag">
            <div class="card">
              <div class="card-header">
                <h5 class="card-title text-center AppointmentSlots">{{'Appointment.appointmentSlots.title' | translate}}</h5>
              </div>
              <div class="card-body">
                <div class=" px-1">
                  <div class="timeslider">
                    <div class="item">
                      <ul>
                        <ng-container *ngIf="appointmentSlots?.length>0">
                          <li *ngFor="let slots of appointmentSlots;let i=index" (click)="onSelectSlot($event,slots)" [id]="'slot'+i">{{slots.availableSlot}}</li>
                        </ng-container>
                        <ng-container *ngIf="appointmentSlots?.length==0">
                          {{'Appointment.appointmentSlots.noSlotsAvailable' | translate}}
                        </ng-container>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
   </div>
  </div>
<footer class="p-3">
    <div class="container p-0">
        <div class="row">
            <div class="col-4">
                <!-- <a class="btn btn-outline-primary" type="button" (click)="backPage()">Back</a> -->
            </div>
            <div class="col-4 text-center">

                <!-- <p class="mb-0">(4 of 7)</p>  -->
            </div>
            <div class="col-4 text-right">
              <a class="btn btn-primary" type="button" (click)="onAddScheduleAppointment()">{{'button.next'|translate}}</a>
            </div>
        </div>
    </div>
  </footer>
